<div class="bj-page">

  <!-- ── Page header ──────────────────────────────────────────── -->
  <div class="bj-header">
    <div class="bj-header__left">
      <div class="bj-header__icon">
        <mat-icon>local_hospital</mat-icon>
      </div>
      <div>
        <h1 class="bj-header__title">Bajas</h1>
        <p class="bj-header__sub">Gestiona las bajas médicas y ausencias del equipo</p>
      </div>
    </div>
    <div class="bj-header__actions">
      <button mat-flat-button class="bj-btn-primary" (click)="createBajaForEmployee()">
        <mat-icon>add</mat-icon> Nueva baja
      </button>
      <app-help key="Personal4"></app-help>
    </div>
  </div>

  <!-- ── Loading ──────────────────────────────────────────────── -->
  <div class="bj-loading" *ngIf="(BajasService.loading$ | async)">
    <div class="bj-loading__icon-wrap"><mat-icon>local_hospital</mat-icon></div>
    <div class="bj-loading__dots"><span></span><span></span><span></span></div>
    <p class="bj-loading__text">Cargando bajas…</p>
  </div>

  <ng-container *ngIf="!(BajasService.loading$ | async)">

    <!-- ── Banner de descarga ─────────────────────────────────── -->
    <div class="bj-download-banner" *ngIf="isDownloading">
      <mat-icon class="bj-download-banner__icon cf-spin-icon">autorenew</mat-icon>
      <span>Descargando documento…</span>
    </div>

    <!-- ── Bajas activas ──────────────────────────────────────── -->
    <div class="bj-section" *ngIf="(BajasService.bajasByUser$ | async)?.length > 0">
      <div class="bj-section__head">
        <div class="bj-section__title-wrap">
          <span class="bj-pill bj-pill--active"></span>
          <h2 class="bj-section__title">Bajas activas</h2>
        </div>
      </div>
      <div class="bj-card">
        <table mat-table [dataSource]="BajasService.bajasByUser$ | async" matSort class="bj-table">

          <ng-container matColumnDef="employee">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Empleado</th>
            <td mat-cell *matCellDef="let element">
              <div class="bj-cell-employee">
                <div class="bj-avatar">{{ nombreEmpleado(element.baja.employees_Id) | slice:0:1 }}</div>
                <span>{{ nombreEmpleado(element.baja.employees_Id) }}</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="cadenaInicio">
            <th mat-header-cell *matHeaderCellDef>Inicio</th>
            <td mat-cell *matCellDef="let element">
              <span class="bj-date">{{ element.baja.cadenaInicio }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="cadenaFin">
            <th mat-header-cell *matHeaderCellDef>Fin</th>
            <td mat-cell *matCellDef="let element">
              <span class="bj-date">{{ element.baja.cadenaFin || '—' }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="motivo">
            <th mat-header-cell *matHeaderCellDef>Motivo</th>
            <td mat-cell *matCellDef="let element">
              <span class="bj-motivo">{{ element.baja.motivo || '—' }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="cadenaFechaSolicitud">
            <th mat-header-cell *matHeaderCellDef>Solicitud</th>
            <td mat-cell *matCellDef="let element">
              <span class="bj-date">{{ element.baja.cadenaFechaSolicitud }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef class="bj-col-actions"></th>
            <td mat-cell *matCellDef="let element" class="bj-col-actions">
              <button mat-icon-button [matMenuTriggerFor]="menuActive" (click)="setRow(element)"
                      class="bj-menu-trigger" matTooltip="Acciones">
                <mat-icon>more_vert</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsActiveBajas"></tr>
          <tr mat-row *matRowDef="let r; columns: displayedColumnsActiveBajas;" class="bj-row"></tr>
        </table>
      </div>
    </div>

    <!-- ── Filtro por empleado ────────────────────────────────── -->
    <div class="bj-filter-card" *ngIf="formBusqueda !== null && empleados?.length > 0">
      <div class="bj-filter-card__head">
        <mat-icon class="bj-filter-card__icon">search</mat-icon>
        <span class="bj-filter-card__label">Buscar bajas por empleado</span>
      </div>
      <form [formGroup]="formBusqueda" (ngSubmit)="obtenerBajasPorEmpleado()" class="bj-filter-form">
        <mat-form-field appearance="outline" class="bj-filter-field">
          <mat-label>Empleado</mat-label>
          <mat-select formControlName="employees_Id">
            <mat-option *ngFor="let e of empleados; trackBy: trackByIndex" [value]="e.uid">
              {{ e.name }}
            </mat-option>
          </mat-select>
          <mat-hint>Selecciona el empleado para ver su historial de bajas</mat-hint>
          <mat-error *ngIf="formBusqueda.controls['employees_Id'].hasError('required')">
            El empleado es <strong>obligatorio</strong>
          </mat-error>
        </mat-form-field>
        <div class="bj-filter-actions">
          <button mat-flat-button class="bj-btn-primary" type="submit">
            <mat-icon>search</mat-icon> Buscar
          </button>
          <button mat-stroked-button class="bj-btn-ghost" type="button" (click)="cancelar()"
                  *ngIf="(BajasService.bajas$ | async)?.length > 0">
            <mat-icon>close</mat-icon> Limpiar
          </button>
        </div>
      </form>
    </div>

    <!-- ── Resultados por empleado ────────────────────────────── -->
    <div class="bj-section" *ngIf="(BajasService.bajas$ | async)?.length > 0">
      <div class="bj-section__head">
        <div class="bj-section__title-wrap">
          <span class="bj-pill bj-pill--hist"></span>
          <h2 class="bj-section__title">
            Historial de bajas —
            <span class="bj-section__emp">{{ nombreEmpleado(formBusqueda.get('employees_Id').value) }}</span>
          </h2>
        </div>
      </div>
      <div class="bj-card">
        <table mat-table [dataSource]="BajasService.bajas$ | async" matSort class="bj-table">

          <ng-container matColumnDef="employee">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Empleado</th>
            <td mat-cell *matCellDef="let element">
              <div class="bj-cell-employee">
                <div class="bj-avatar">{{ nombreEmpleado(element.baja.employees_Id) | slice:0:1 }}</div>
                <span>{{ nombreEmpleado(element.baja.employees_Id) }}</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="cadenaInicio">
            <th mat-header-cell *matHeaderCellDef>Inicio</th>
            <td mat-cell *matCellDef="let element">
              <span class="bj-date">{{ element.baja.cadenaInicio }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="cadenaFin">
            <th mat-header-cell *matHeaderCellDef>Fin</th>
            <td mat-cell *matCellDef="let element">
              <span class="bj-date">{{ element.baja.cadenaFin || '—' }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="motivo">
            <th mat-header-cell *matHeaderCellDef>Motivo</th>
            <td mat-cell *matCellDef="let element">
              <span class="bj-motivo">{{ element.baja.motivo || '—' }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="cadenaFechaSolicitud">
            <th mat-header-cell *matHeaderCellDef>Solicitud</th>
            <td mat-cell *matCellDef="let element">
              <span class="bj-date">{{ element.baja.cadenaFechaSolicitud }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef class="bj-col-actions"></th>
            <td mat-cell *matCellDef="let element" class="bj-col-actions">
              <button mat-icon-button [matMenuTriggerFor]="menuEmployee" (click)="setRow(element)"
                      class="bj-menu-trigger" matTooltip="Acciones">
                <mat-icon>more_vert</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsByEmployee"></tr>
          <tr mat-row *matRowDef="let r; columns: displayedColumnsByEmployee;" class="bj-row"></tr>
        </table>
      </div>
    </div>

  </ng-container>

</div>

<!-- ── Menú bajas activas ────────────────────────────────────── -->
<mat-menu #menuActive="matMenu">
  <button mat-menu-item (click)="editar()">
    <mat-icon>edit</mat-icon><span>Editar</span>
  </button>
  <mat-divider></mat-divider>
  <button mat-menu-item class="bj-action-danger" (click)="eliminar()">
    <mat-icon>delete</mat-icon><span>Borrar</span>
  </button>
  <ng-container *ngIf="tieneDocumentos(row)">
    <mat-divider></mat-divider>
    <button mat-menu-item *ngFor="let doc of row.documentos; let i = index; trackBy: trackByIndex"
            (click)="descargarDocumento(doc.fileGuid)" [disabled]="isDownloading">
      <mat-icon>{{ isDownloading ? 'autorenew' : 'file_download' }}</mat-icon>
      <span>{{ isDownloading ? 'Descargando…' : 'Documento ' + (i + 1) }}</span>
    </button>
  </ng-container>
</mat-menu>

<!-- ── Menú historial empleado ───────────────────────────────── -->
<mat-menu #menuEmployee="matMenu">
  <button mat-menu-item (click)="editar()">
    <mat-icon>edit</mat-icon><span>Editar</span>
  </button>
  <mat-divider></mat-divider>
  <button mat-menu-item class="bj-action-danger" (click)="eliminar()">
    <mat-icon>delete</mat-icon><span>Borrar</span>
  </button>
  <ng-container *ngIf="tieneDocumentos(row)">
    <mat-divider></mat-divider>
    <button mat-menu-item *ngFor="let doc of row.documentos; let i = index; trackBy: trackByIndex"
            (click)="descargarDocumento(doc.fileGuid)" [disabled]="isDownloading">
      <mat-icon>{{ isDownloading ? 'autorenew' : 'file_download' }}</mat-icon>
      <span>{{ isDownloading ? 'Descargando…' : 'Documento ' + (i + 1) }}</span>
    </button>
  </ng-container>
</mat-menu>
